import React from "react";
import {PriceInfo} from "../types";
import MedicationSummaryPriceElement from "./medication-summary-price-element";

export interface MedicationSummaryPriceCardProp {
    basisPrice: PriceInfo;
    priceToPay: PriceInfo;
    saving: PriceInfo;
}

const calculateSavingPercentage = (basisPrice: PriceInfo, saving: PriceInfo) => {
    return "-" + Math.min(Math.max(parseInt((100 * saving.price.amount / basisPrice.price.amount).toFixed(0)), 1), 99) + "%";
}

const MedicationSummaryPriceCard = ({basisPrice, priceToPay, saving}: MedicationSummaryPriceCardProp) => {

    return (
        <pui-section class="medication-summary-price-card" flowDirection="vertical" secondaryAxisArrangement="start"
                     padding="med-small" paddingbottom="small">
            <pui-section flowDirection="horizontal" secondaryAxisArrangement="center">
                <pui-text class="saving-percentage" input={calculateSavingPercentage(basisPrice, saving)}/>
                <MedicationSummaryPriceElement price={priceToPay.price}/>
                <pui-text class="price-to-pay-message" input={priceToPay.message}/>
            </pui-section>
            <pui-section class="retail-price-saving" flowDirection="horizontal" secondaryAxisArrangement="center" spacingtop="mini"
                         spacingbottom="mini">
                <pui-text input={`${basisPrice.label}`} spacingright="mini" textsize="small-medium"/>
                <pui-text input={`${basisPrice.price.currencySymbol}${basisPrice.price.amount.toFixed(2)}`}
                          textsize="small-medium" textdecorationline="line-through"/>
            </pui-section>
            <pui-text input={saving.message} textsize="small-medium"/>
        </pui-section>
    )
}

export default MedicationSummaryPriceCard;